import script from "./Events.vue?vue&type=script&setup=true&lang=js"
export * from "./Events.vue?vue&type=script&setup=true&lang=js"

import "./Events.vue?vue&type=style&index=0&id=dfda8fc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfda8fc4"]])

export default __exports__